import type { Chain } from "~/tools/chain";
import type { Defaultable } from "~/tools/defaultable";
import type { Functor } from "~/tools/functor";
import { Matchable } from "~/tools/matchable";

class Success<TValue> extends Matchable<"success"> implements Functor<TValue>, Chain<TValue>, Defaultable<TValue> {
	protected readonly __name = "success" as const;

	public constructor(public readonly value: TValue) {
		super();
	}

	public isIdle(): false {
		return false;
	}

	public isLoading(): false {
		return false;
	}

	public isFailure(): false {
		return false;
	}

	public isSuccess(): this is Success<TValue> {
		return true;
	}

	public getOrElse(): TValue {
		return this.value;
	}

	public transform<TNextValue>(fn: (value: TValue) => TNextValue): Success<TNextValue> {
		return new Success(fn(this.value));
	}

	public transformFailure(): this {
		return this;
	}

	public chain<TNextValue extends Chain<unknown>>(fn: (value: TValue) => TNextValue): TNextValue {
		return fn(this.value);
	}
}

export { Success };
